export const regFlow = "REGISTRATION_FLOW";
export const sprFlow = "SPR_FLOW";
export const sprWithJobIdFlow = "SPR_WITH_JOBID_FLOW";

export const organicMarketingChannels = [
  "google",
  "bing",
  "adzuna",
  "yahoo",
  "jobtome",
  "duckduckgo",
  "baidu",
  "ask.com",
  "sogou",
  "yandex",
  "babylon",
  "so.com",
  "privatejobshub",
  "search.smt.docomo",
  "msn",
  "Lycos",
];

export const yearlySalaryMode = "7cad9bf9-222e-11e9-9330-1418775c7275";
export const monthlySalaryMode = "69a8f26e-222e-11e9-9330-1418775c7275";
